import { createBookingOnboardingService } from '@shared/api/booking-onboarding.service'
import { authorizedHttpClient } from './http-client'

export const BookingOnboardingService = createBookingOnboardingService(
  authorizedHttpClient,
  import.meta.env.VITE_API_URL,
)
